import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useT } from 'talkr';
import numerous from 'numerous';
import enLocale from 'numerous/locales/en';
import ruLocale from 'numerous/locales/ru';
import frLocale from 'numerous/locales/fr';
import deLocale from 'numerous/locales/de';
import itLocale from 'numerous/locales/it';
import ptLocale from 'numerous/locales/pt';
import esLocale from 'numerous/locales/es';
import zhLocale from 'numerous/locales/zh';
import jaLocale from 'numerous/locales/ja';
import koLocale from 'numerous/locales/ko';
import steps from '../../../survey/steps';
import questions from '../../../survey/questions';
import WeightChart from '../../../components/weightChart';
import BmiResultBlock from '../../../components/bmi';
import common from '../../index.module.scss';
import s from './index.module.scss';

function BodyMass (props) {
	const { T } = useT();
	const currentStep = useSelector((state) => state.steps.currentStep);
	const currentWeightValue = questions.getAnswers({ questionName: 'weight' }).units.value === 'kg'
		? questions.getAnswers({ questionName: 'weight' }).value.value
		: questions.getAnswers({ questionName: 'weight' }).value.value * 0.453592;
	const targetWeightValue = questions.getAnswers({ questionName: 'target_weight' }).units.value === 'kg'
		? questions.getAnswers({ questionName: 'target_weight' }).value.value
		: questions.getAnswers({ questionName: 'target_weight' }).value.value * 0.453592;
	const heightValue = questions.getAnswers({ questionName: 'height' }).units.value === 'cm'
		? questions.getAnswers({ questionName: 'height' }).value.value
		: questions.getAnswers({ questionName: 'height' }).value.value * 30.48 / 12;
	const gainWeight = +currentWeightValue < +targetWeightValue;
	const currentWeight = questions.getAnswers({ questionName: 'weight' });
	const targetWeight = questions.getAnswers({ questionName: 'target_weight' });
	const weightPerDay = gainWeight ? 0.2 : 0.1285714285714;
	const difference = !gainWeight ? currentWeightValue - targetWeightValue : targetWeightValue - currentWeightValue;
	const date = new Date();
	const dateFormated = date.toLocaleDateString();
	const dateMiddle = new Date(Date.now() + (difference / 2 / weightPerDay) * 86400000);
	const dateMiddleFormated = dateMiddle.toLocaleDateString();
	const dateFinal = new Date(Date.now() + (difference / weightPerDay) * 86400000);
	const dateFinalFormated = dateFinal.toLocaleDateString();
	let currentWeightToShow = (+(+currentWeight.value.value).toFixed(2)).toLocaleString(undefined);
	let targetWeightToShow = (+(+targetWeight.value.value).toFixed(2)).toLocaleString(undefined);
	let targetUnitsToShow = currentWeight.units.value;
	let currentUnitsToShow = currentWeight.units.value;

	if (targetWeight.units.value !== currentWeight.units.value && targetWeight.units.value === 'lbs') {
		targetWeightToShow = (+(targetWeight.value.value * 0.453592).toFixed(2)).toLocaleString(undefined);
		targetUnitsToShow = 'kg';
	}

	if (targetWeight.units.value !== currentWeight.units.value && targetWeight.units.value === 'kg') {
		currentWeightToShow = (+(currentWeight.value.value * 0.453592).toFixed(2)).toLocaleString(undefined);
		currentUnitsToShow = 'kg';
		targetUnitsToShow = 'kg';
	}

	const intermediateWeight = !gainWeight
		? +currentWeightToShow - ((+currentWeightToShow - +targetWeightToShow) / 2)
		: +currentWeightToShow + ((+targetWeightToShow - +currentWeightToShow) / 2);

	const diff = dateFinal.getTime() - date.getTime();
	const days = Math.round(diff / (1000 * 3600 * 24));

	numerous.registerLocale([
		enLocale,
		ruLocale,
		frLocale,
		deLocale,
		itLocale,
		ptLocale,
		esLocale,
		zhLocale,
		jaLocale,
		koLocale
	]);

	const { pluralize } = numerous.create(window.userLang);

	const localesDays = {
		other: window.locales.days_other,
		zero: window.locales.days_zero,
		one: window.locales.days_one,
		two: window.locales.days_two,
		few: window.locales.days_few,
		many: window.locales.days_many
	};

	const localesWeeks = {
		other: window.locales.weeks_other,
		zero: window.locales.weeks_zero,
		one: window.locales.weeks_one,
		two: window.locales.weeks_two,
		few: window.locales.weeks_few,
		many: window.locales.weeks_many
	};

	let duration = `${Math.round(days)} ${pluralize(Math.round(days), localesDays)}`;

	if (days > 30) {
		duration = `${Math.round(days / 7)} ${pluralize(Math.round(days / 7), localesWeeks)}`;
	}

	const title = T('duration_time', { duration });

	useEffect(() => {
		steps.setStepStatus({
			stepName: 'body_mass',
			stepStatus: true
		});
	}, [currentStep]);

	return (
		<div className={`${s.bodyMass} ${gainWeight ? s.gainWeight : ''}`}>
			<h1 className={common.stepTitle}>{title}</h1>
			<div className={common.stepDescription}>{T('duration_time_description')}</div>
			<WeightChart
				animate={props.isThisCurrentStep}
				gainWeight={gainWeight}
				currentWeightToShow={currentWeightToShow}
				currentUnitsToShow={currentUnitsToShow}
				intermediateWeight={(+(+intermediateWeight).toFixed(2)).toLocaleString(undefined)}
				targetWeight={targetWeightToShow}
				targetWeightUnits={targetUnitsToShow}
				dateFirst={dateFormated}
				dateSecond={dateMiddleFormated}
				dateThird={dateFinalFormated}
				duration={duration}
			/>
			<BmiResultBlock
				weight={currentWeightValue}
				height={heightValue}
			/>
		</div>
	);
}

export default BodyMass;
